export const PUBLIC_PRICE_PLANS = `
  query publicPricePlans {
    publicPricePlans {
      __typename
      active {
        code
        name
        id
        ppType
        status
        subtype
        priceUSD
        units
        validity
        validFrom
      }
    }
  }
`;

export const PRIVATE_PRICE_PLANS = `
  query pricePlansPrivate($ppType: PricePlanType!) {
    pricePlans(ppType: $ppType) {
      __typename
      active {
        code
        name
        id
        ppType
        status
        subtype
        priceUSD
        units
        validity
        validFrom
      }
      pending {
        code
        name
        id
        ppType
        status
        subtype
        priceUSD
        units
        validity
        validFrom
      }
      archived {
        code
        name
        id
        ppType
        status
        subtype
        priceUSD
        units
        validity
        validFrom
      }
      suspended {
        code
        name
        id
        ppType
        status
        subtype
        priceUSD
        units
        validity
        validFrom
      }
    }
  }
`;
